import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatCurrency',
})
export class FormatCurrencyPipe implements PipeTransform {
    transform(value: number, currencyCode?: string | null): string | null {
        if (!value && value !== 0) {
            return '';
        }

        return new CurrencyPipe('en-GB').transform(
            value,
            currencyCode || undefined,
            'symbol',
            '1.0',
        );
    }
}
